import React, { useContext } from 'react';
import { ThemeContext } from './context/ThemeContext';
import react from './img/react.png'
import javascript from './img/js.png'
import tailwind from './img/tailwind.png'
import framer from './img/framer.svg'
import solidity from './img/solidity.png'
import foundry from './img/foundry.png'
import gcp from './img/gclogo.png'


const Stack = () => {

    const { darkMode } = useContext(ThemeContext);

    return (
        <div id='home' className='flex items-center flex-col justify-center py-10'>
            <h1 className='text-3xl mb-10'>My Skills</h1>

            <div className='flex items-center justify-center flex-wrap gap-6'>

                <div className={`p-8 border-[0.5px] ${darkMode ? "border-white" : "border-black"} flex items-center justify-center flex-col w-40 h-40 lg:hover:-translate-y-5 transition-all`}>
                    <img src={javascript} alt='javascript-logo' className='' />
                    Javascript
                </div>
                
                <div className={`p-8 fit border-[0.5px] ${darkMode ? "border-white" : "border-black"} flex items-center justify-center flex-col w-40 h-40 lg:hover:-translate-y-5 transition-all`}>
                    <img src={react} alt='react-logo' className='' />
                    React.js
                </div>

                <div className={`p-8 border-[0.5px] ${darkMode ? "border-white" : "border-black"} flex items-center justify-center flex-col w-40 h-40 lg:hover:-translate-y-5 transition-all`}>
                    <img src='/next.png' alt='next-logo' className='' />
                    Next.js
                </div>

                <div className={`p-8 border-[0.5px] ${darkMode ? "border-white" : "border-black"} flex items-center justify-center flex-col w-40 h-40 lg:hover:-translate-y-5 transition-all`}>
                    <img src={tailwind} alt='tailwind-logo' className='' />
                    TailwindCSS
                </div>

                <div className={`p-6 border-[0.5px] ${darkMode ? "border-white" : "border-black"} flex items-center justify-center flex-col w-40 h-40 lg:hover:-translate-y-5 transition-all`}>
                    <img src={gcp} alt='google-cloud-logo' className='h-16' />
                    Google Cloud
                </div>

                <div className={`p-6 border-[0.5px] ${darkMode ? "border-white" : "border-black"} flex items-center justify-center flex-col w-40 h-40 lg:hover:-translate-y-5 transition-all`}>
                    <img src={framer} alt='framer-motion-logo' className='h-16' />
                    Framer Motion
                </div>

                <div className={`p-8 border-[0.5px] ${darkMode ? "border-white" : "border-black"} flex items-center justify-center flex-col w-40 h-40 lg:hover:-translate-y-5 transition-all`}>
                    <img src={solidity} alt='solidity-logo' className='h-20' />
                    Solidity
                </div>

                <div className={`p-8 border-[0.5px] ${darkMode ? "border-white" : "border-black"} flex items-center justify-center flex-col w-40 h-40 lg:hover:-translate-y-5 transition-all`}>
                    <img src={foundry} alt='foundry-logo' className='' />
                    Foundry
                </div>

            </div>
        </div>
    );
}

export default Stack;